import { deleteAsync, getAsync, patchAsync, postAsync, putAsync } from "./http-client";

const UserApi = {
  getInfo: async (shopIdx) => {
    return await getAsync(`/shop/editShopInfo/${shopIdx}`);
  },
  editInfo: async (data) => {
    return await patchAsync("/shop/editShopInfo", data);
  },
  sendOtp: async (data) => {
    return await postAsync("/shop/sendOtp", data);
  },
  verifyChangePhoneOtp: async (data) => {
    return await postAsync("/shop/verifyChangePhoneOtp", data);
  },
  getShopInfoBeforeDelete: async (shopIdx) => {
    return await getAsync(`/shop/findShopInfoBeforeDeleteAccount/${shopIdx}`);
  },
  deleteAccount: async (data) => {
    return await deleteAsync("/ceo/deletedAccount", data);
  },
  deletePremium: async (data) => {
    return await deleteAsync("/ceo/deletedPremium", data);
  },
  cancelDeletePremium: async (data) => {
    return await putAsync("/ceo/cancelDeletedPremimum", data);
  },
  cancelDeleteAccount: async (data) => {
    return await putAsync("/ceo/cancelDeletedAccount", data);
  },
};
export default UserApi;
